import { ProductTemplate } from './product';

export default ProductTemplate;
